const translations = {
  de: {
    nav_how: "So funktioniert's",
    nav_features: "Features",
    nav_faq: "FAQ",
    nav_login: "Anmelden",
    nav_cta: "Jetzt starten",

    hero_badge: "KI-gestütztes Looksmaxxing",
    hero_title_1: "Dein Glow-Up,",
    hero_title_2: "wissenschaftlich",
    hero_title_3: "visualisiert.",
    hero_desc: "Lade ein Selfie hoch und sieh in Sekunden, wie du mit optimiertem Hautbild, Haarstyle und Gesichtszügen aussehen könntest — mit einem konkreten Plan, wie du dahin kommst.",
    hero_cta: "Jetzt starten",
    hero_cta_join: "Tritt dem Club bei",
    hero_sub: "10 Bilder + 30 Nachrichten",
    ba_label: "Ergebnisse",
    ba_title: "Sieh die Veränderung",

    trust_label: "Basierend auf",
    trust_items: ["GPT-4 Vision", "Gemini Imagen", "Facial Aesthetics Research", "10.000+ Analysen"],

    steps_label: "Wie es funktioniert",
    steps_title_1: "In vier Schritten zu",
    steps_title_2: "deinem besten Ich",
    step_1_title: "Foto hochladen",
    step_1_desc: "Lade ein frontales Selfie mit gutem Licht hoch — kein Filter, kein Makeup.",
    step_2_title: "KI-Analyse",
    step_2_desc: "Unsere KI analysiert Gesichtszüge, Proportionen, Hautbild und Style-Potenzial.",
    step_3_title: "Visualisierung",
    step_3_desc: "Sieh dein optimiertes Ich — mit realistischen Verbesserungen in Echtzeit generiert.",
    step_4_title: "Persönlicher Plan",
    step_4_desc: "Erhalte einen konkreten, umsetzbaren Plan mit Routinen und Tipps.",

    compare_label: "Warum Beauly",
    compare_title_1: "Der alte Weg vs.",
    compare_title_2: "der neue Weg",
    old_title: "Der alte Weg",
    old_items: [
      "Stundenlang Youtube-Videos schauen",
      "Generische Tipps ohne Personalisierung",
      "Keine Vorschau — reines Raten",
      "Teure Beratungen beim Stylisten",
      "Trial & Error ohne Ergebnis",
    ],
    new_title: "Der neue Weg",
    new_items: [
      "Sofortige KI-Analyse in Sekunden",
      "100% personalisiert auf dein Gesicht",
      "Realistische Vorschau der Veränderungen",
      "Konkreter Schritt-für-Schritt Plan",
      "Wissenschaftlich fundierte Empfehlungen",
    ],

    cat_label: "Was wir analysieren",
    cat_title_1: "Jedes Detail deines Aussehens,",
    cat_title_2: "optimiert",
    cat_skin_title: "Hautbild",
    cat_skin_desc: "Klarere, strahlende Haut durch personalisierte Skincare-Routinen und Empfehlungen.",
    cat_hair_title: "Haarstyle",
    cat_hair_desc: "Der perfekte Schnitt für deine Gesichtsform — mit Styling-Anleitung und Tipps.",
    cat_face_title: "Gesichtsstruktur",
    cat_face_desc: "Kieferlinie, Wangenknochen, Symmetrie — sieh wie kleine Veränderungen großen Impact haben.",
    cat_glasses_title: "Brille & Accessoires",
    cat_glasses_desc: "Welche Rahmenform betont dein Gesicht? Welche Accessoires passen zu deinem Typ?",
    cat_beard_title: "Bart & Augenbrauen",
    cat_beard_desc: "Optimale Form, Länge und Pflege — abgestimmt auf deine Gesichtsproportionen.",
    cat_fitness_title: "Fitness & Körper",
    cat_fitness_desc: "Wie Gewichtsveränderungen dein Gesicht beeinflussen — mit realistischer Vorschau.",

    stat_1_value: "3.800+",
    stat_1_label: "Transformationen",
    stat_2_value: "4.7",
    stat_2_label: "Nutzerbewertung",
    stat_3_value: "<30s",
    stat_3_label: "bis zum Ergebnis",

    test_label: "Erfahrungen",
    test_title_1: "Was unsere Nutzer",
    test_title_2: "sagen",
    test_1_text: "Ich hätte nie gedacht, dass ein anderer Haarschnitt so viel Unterschied macht. Beauly hat mir genau gezeigt, welcher zu meiner Gesichtsform passt.",
    test_1_name: "Lukas M.",
    test_1_loc: "Wien, Österreich",
    test_2_text: "Die Skincare-Empfehlungen haben mein Hautbild in 4 Wochen sichtbar verbessert. Endlich Tipps, die wirklich auf mich zugeschnitten sind.",
    test_2_name: "Sarah K.",
    test_2_loc: "Los Angeles, USA",
    test_3_text: "Mega cool zu sehen, wie ich mit definierter Jawline aussehen würde — und der Fitness-Plan dazu ist realistisch und machbar.",
    test_3_name: "Wang Wei",
    test_3_loc: "Shanghai, China",
    test_4_text: "Beauly hat mir geholfen, meinen Style komplett zu überdenken. Die Visualisierungen sind unglaublich realistisch.",
    test_4_name: "Anna L.",
    test_4_loc: "Madrid, Spanien",
    test_5_text: "Endlich eine Plattform, die mir konkret zeigt, was möglich ist. Die Bartempfehlung war ein Gamechanger.",
    test_5_name: "Max B.",
    test_5_loc: "Moskau, Russland",
    test_6_text: "Die Brillenberatung hat mich überzeugt. Hätte nie gedacht, dass die Rahmenform so viel ausmacht.",
    test_6_name: "Elena S.",
    test_6_loc: "Lissabon, Portugal",

    faq_label: "FAQ",
    faq_title_1: "Häufig gestellte",
    faq_title_2: "Fragen",
    faq_1_q: "Wie funktioniert die KI-Analyse?",
    faq_1_a: "Unsere KI nutzt fortschrittliche Bildgenerierung und Gesichtsanalyse, um dein Foto zu analysieren. Anschließend werden realistische Verbesserungen visualisiert — alles basierend auf ästhetischen Proportionen und bewiesenen Methoden.",
    faq_2_q: "Sind meine Fotos sicher?",
    faq_2_a: "Ja. Deine Fotos werden verschlüsselt übertragen und nie an Dritte weitergegeben. Du kannst deine Daten jederzeit löschen.",
    faq_3_q: "Was erwartet mich bei Beauly?",
    faq_3_a: "Du erhältst eine komplette KI-Analyse deines Gesichts, realistische Visualisierungen und einen persönlichen Plan — dein Ergebnis ist in unter 30 Sekunden da.",
    faq_4_q: "Werden die Bilder realistisch?",
    faq_4_a: "Ja. Wir nutzen modernste Bildgenerierung, die natürliche und realistische Ergebnisse liefert — keine übertriebenen Filter oder unrealistische Veränderungen.",
    faq_5_q: "Funktioniert es für alle Geschlechter?",
    faq_5_a: "Absolut. Beauly funktioniert für alle Geschlechter, Ethnien und Altersgruppen. Die Empfehlungen werden individuell angepasst.",

    cta_title_1: "Bereit für dein",
    cta_title_2: "bestes Aussehen?",
    cta_desc: "Dein Ergebnis ist in unter 30 Sekunden da. Einfach Selfie hochladen und loslegen.",
    cta_button: "Jetzt loslegen",

    footer_how: "So funktioniert's",
    footer_features: "Features",
    footer_faq: "FAQ",

    auth_back: "Zurück",
    auth_subtitle: "Dein persönlicher Styling-Assistent",
    auth_login: "Anmelden",
    auth_register: "Registrieren",
    auth_email: "E-Mail",
    auth_password: "Passwort",
    auth_name: "Name",
    auth_no_account: "Noch kein Konto? Registrieren",
    auth_has_account: "Bereits registriert? Anmelden",

    chat_new: "Neue Analyse",
    chat_no_chats: "Noch keine Chats",
    chat_default_title: "Beauly — Dein Styling-Assistent",
    chat_welcome: "Willkommen bei Beauly",
    chat_welcome_desc: "Lade ein Foto von dir hoch und ich zeige dir, wie du mit einem anderen Haarschnitt, Bart oder Style aussehen könntest.",
    chat_suggest_1: "Analysiere mein Gesicht",
    chat_suggest_2: "Welcher Haarschnitt passt zu mir?",
    chat_suggest_3: "Skincare-Routine für Anfänger",
    chat_suggest_4: "Zeig mir mein Glow-Up",
    chat_upload: "Foto hochladen",
    chat_image_active: "Bildmodus aktiv",
    chat_image_enable: "Bildmodus aktivieren",
    chat_placeholder: "Nachricht an Beauly...",
    chat_placeholder_image: "Beschreibe die gewünschte Veränderung...",
    chat_image_hint: "Bildmodus aktiv — Lade ein Foto hoch und beschreibe die gewünschte Veränderung",
    chat_generating: "Bild wird generiert...",
    chat_generated: "Generiertes Bild",
    chat_disclaimer: "Beauly kann Fehler machen. Ergebnisse sind KI-generiert und dienen zur Orientierung.",
    chat_logout: "Abmelden",
    chat_new_conv: "Neue Unterhaltung",
    chat_delete_account: "Account löschen",
    chat_delete_title: "Account löschen?",
    chat_delete_warning: "Alle deine Daten, Chatverläufe und Bilder werden unwiderruflich gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.",
    chat_delete_cancel: "Abbrechen",
    chat_delete_continue: "Weiter",
    chat_delete_type_title: "Bestätigung erforderlich",
    chat_delete_type_desc: "Gib deinen Namen ein um die Löschung zu bestätigen:",
    chat_delete_confirm: "Endgültig löschen",
    auth_error_name: "Bitte gib einen Namen ein.",
    auth_error_email: "Bitte gib eine E-Mail ein.",
    auth_error_password: "Bitte gib ein Passwort ein.",
    paywall_title: "Schalte Beauly frei",
    paywall_desc: "Einmalzahlung — kein Abo, keine versteckten Kosten.",
    paywall_period: "einmalig",
    paywall_feature_1: "KI-Analyse deines Gesichts",
    paywall_feature_2: "Realistische Vorher/Nachher Visualisierung",
    paywall_feature_3: "Persönlicher Styling-Plan",
    paywall_feature_4: "Unbegrenzte Chat-Gespräche",
    paywall_cta: "Jetzt freischalten",
    paywall_logout: "Abmelden",
    camera_title: "Foto aufnehmen",
    camera_take: "Kamera öffnen",
    camera_gallery: "Aus Galerie wählen",
    camera_retake: "Nochmal",
    camera_send: "Analysieren",
    credits_messages: "Nachrichten",
    credits_images: "Bilder",
    credits_buy: "Credits kaufen",
    credits_exhausted_title: "Credits aufgebraucht",
    credits_exhausted_desc: "Du hast alle Credits verbraucht. Kaufe neue Credits um Beauly weiter zu nutzen.",
    credits_exhausted_info: "10 Bilder + 30 Nachrichten pro Kauf",
    credits_buy_now: "Jetzt Credits kaufen",
    credits_later: "Später",
  },

  en: {
    // Navbar
    nav_how: "How it works",
    nav_features: "Features",
    nav_faq: "FAQ",
    nav_login: "Login",
    nav_cta: "Get started",

    // Hero
    hero_badge: "AI-powered Looksmaxxing",
    hero_title_1: "Your Glow-Up,",
    hero_title_2: "scientifically",
    hero_title_3: "visualized.",
    hero_desc: "Upload a selfie and see in seconds how you could look with optimized skin, hairstyle, and facial features — with a concrete plan to get there.",
    hero_cta: "Get started",
    hero_cta_join: "Join the Club",
    hero_sub: "10 images + 30 messages",
    ba_label: "Results",
    ba_title: "See the transformation",

    // Trust
    trust_label: "Powered by",
    trust_items: ["GPT-4 Vision", "Gemini Imagen", "Facial Aesthetics Research", "10,000+ Analyses"],

    // Steps
    steps_label: "How it works",
    steps_title_1: "Four steps to",
    steps_title_2: "your best self",
    step_1_title: "Upload Photo",
    step_1_desc: "Upload a frontal selfie with good lighting — no filter, no makeup.",
    step_2_title: "AI Analysis",
    step_2_desc: "Our AI analyzes facial features, proportions, skin quality, and style potential.",
    step_3_title: "Visualization",
    step_3_desc: "See your optimized self — with realistic improvements generated in real-time.",
    step_4_title: "Personal Plan",
    step_4_desc: "Get a concrete, actionable plan with routines and tips.",

    // Old vs New
    compare_label: "Why Beauly",
    compare_title_1: "The old way vs.",
    compare_title_2: "the new way",
    old_title: "The old way",
    old_items: [
      "Hours watching YouTube videos",
      "Generic tips without personalization",
      "No preview — pure guesswork",
      "Expensive stylist consultations",
      "Trial & error with no results",
    ],
    new_title: "The new way",
    new_items: [
      "Instant AI analysis in seconds",
      "100% personalized to your face",
      "Realistic preview of changes",
      "Concrete step-by-step plan",
      "Science-backed recommendations",
    ],

    // Categories
    cat_label: "What we analyze",
    cat_title_1: "Every detail of your appearance,",
    cat_title_2: "optimized",
    cat_skin_title: "Skin",
    cat_skin_desc: "Clearer, radiant skin through personalized skincare routines and recommendations.",
    cat_hair_title: "Hairstyle",
    cat_hair_desc: "The perfect cut for your face shape — with styling instructions and tips.",
    cat_face_title: "Facial Structure",
    cat_face_desc: "Jawline, cheekbones, symmetry — see how small changes make a big impact.",
    cat_glasses_title: "Glasses & Accessories",
    cat_glasses_desc: "Which frame shape flatters your face? Which accessories match your type?",
    cat_beard_title: "Beard & Eyebrows",
    cat_beard_desc: "Optimal shape, length, and care — tailored to your facial proportions.",
    cat_fitness_title: "Fitness & Body",
    cat_fitness_desc: "How weight changes affect your face — with a realistic preview.",

    // Stats
    stat_1_value: "3,800+",
    stat_1_label: "Transformations",
    stat_2_value: "4.7",
    stat_2_label: "User Rating",
    stat_3_value: "<30s",
    stat_3_label: "to results",

    // Testimonials
    test_label: "Testimonials",
    test_title_1: "What our users",
    test_title_2: "say",
    test_1_text: "I never thought a different haircut could make such a difference. Beauly showed me exactly which one fits my face shape.",
    test_1_name: "Lucas M.",
    test_1_loc: "Vienna, Austria",
    test_2_text: "The skincare recommendations visibly improved my skin in 4 weeks. Finally tips that are truly tailored to me.",
    test_2_name: "Sarah K.",
    test_2_loc: "Los Angeles, USA",
    test_3_text: "Super cool to see how I'd look with a defined jawline — and the fitness plan is realistic and doable.",
    test_3_name: "Wang Wei",
    test_3_loc: "Shanghai, China",
    test_4_text: "Beauly helped me completely rethink my style. The visualizations are incredibly realistic.",
    test_4_name: "Anna L.",
    test_4_loc: "Madrid, Spain",
    test_5_text: "Finally a platform that shows me concretely what's possible. The beard recommendation was a gamechanger.",
    test_5_name: "Max B.",
    test_5_loc: "Moscow, Russia",
    test_6_text: "The glasses consultation convinced me. I never thought the frame shape could make such a difference.",
    test_6_name: "Elena S.",
    test_6_loc: "Lisbon, Portugal",

    // FAQ
    faq_label: "FAQ",
    faq_title_1: "Frequently asked",
    faq_title_2: "Questions",
    faq_1_q: "How does the AI analysis work?",
    faq_1_a: "Our AI uses advanced image generation and facial analysis to analyze your photo. Realistic improvements are then visualized — all based on aesthetic proportions and proven methods.",
    faq_2_q: "Are my photos safe?",
    faq_2_a: "Yes. Your photos are transferred encrypted and never shared with third parties. You can delete your data at any time.",
    faq_3_q: "What can I expect from Beauly?",
    faq_3_a: "You get a complete AI analysis of your face, realistic visualizations, and a personal plan — your result is ready in under 30 seconds.",
    faq_4_q: "Are the images realistic?",
    faq_4_a: "Yes. We use state-of-the-art image generation that delivers natural and realistic results — no exaggerated filters or unrealistic changes.",
    faq_5_q: "Does it work for all genders?",
    faq_5_a: "Absolutely. Beauly works for all genders, ethnicities, and age groups. Recommendations are individually tailored.",

    // Final CTA
    cta_title_1: "Ready for your",
    cta_title_2: "best look?",
    cta_desc: "Your result is ready in under 30 seconds. Just upload a selfie and go.",
    cta_button: "Get started now",

    // Footer
    footer_how: "How it works",
    footer_features: "Features",
    footer_faq: "FAQ",

    // Auth
    auth_back: "Back",
    auth_subtitle: "Your personal styling assistant",
    auth_login: "Sign In",
    auth_register: "Sign Up",
    auth_email: "Email",
    auth_password: "Password",
    auth_name: "Name",
    auth_no_account: "Don't have an account? Sign Up",
    auth_has_account: "Already registered? Sign In",

    // Chat
    chat_new: "New Analysis",
    chat_no_chats: "No chats yet",
    chat_default_title: "Beauly — Your Styling Assistant",
    chat_welcome: "Welcome to Beauly",
    chat_welcome_desc: "Upload a photo of yourself and I'll show you how you could look with a different haircut, beard, or style.",
    chat_suggest_1: "Analyze my face",
    chat_suggest_2: "Which haircut suits me?",
    chat_suggest_3: "Skincare routine for beginners",
    chat_suggest_4: "Show me my glow-up",
    chat_upload: "Upload photo",
    chat_image_active: "Image mode active",
    chat_image_enable: "Enable image mode",
    chat_placeholder: "Message Beauly...",
    chat_placeholder_image: "Describe the desired change...",
    chat_image_hint: "Image mode active — Upload a photo and describe the desired change",
    chat_generating: "Generating image...",
    chat_generated: "Generated image",
    chat_disclaimer: "Beauly can make mistakes. Results are AI-generated and for guidance only.",
    chat_logout: "Sign out",
    chat_new_conv: "New Conversation",
    chat_delete_account: "Delete account",
    chat_delete_title: "Delete account?",
    chat_delete_warning: "All your data, chat history, and images will be permanently deleted. This action cannot be undone.",
    chat_delete_cancel: "Cancel",
    chat_delete_continue: "Continue",
    chat_delete_type_title: "Confirmation required",
    chat_delete_type_desc: "Type your name to confirm deletion:",
    chat_delete_confirm: "Delete permanently",
    auth_error_name: "Please enter your name.",
    auth_error_email: "Please enter your email.",
    auth_error_password: "Please enter a password.",
    paywall_title: "Unlock Beauly",
    paywall_desc: "One-time payment — no subscription, no hidden costs.",
    paywall_period: "one-time",
    paywall_feature_1: "AI analysis of your face",
    paywall_feature_2: "Realistic before/after visualization",
    paywall_feature_3: "Personal styling plan",
    paywall_feature_4: "Unlimited chat conversations",
    paywall_cta: "Unlock now",
    paywall_logout: "Sign out",
    camera_title: "Take a photo",
    camera_take: "Open camera",
    camera_gallery: "Choose from gallery",
    camera_retake: "Retake",
    camera_send: "Analyze",
    credits_messages: "Messages",
    credits_images: "Images",
    credits_buy: "Buy credits",
    credits_exhausted_title: "Credits used up",
    credits_exhausted_desc: "You've used all your credits. Buy more to keep using Beauly.",
    credits_exhausted_info: "10 images + 30 messages per purchase",
    credits_buy_now: "Buy credits now",
    credits_later: "Later",
  },

  es: {
    nav_how: "Como funciona",
    nav_features: "Funciones",
    nav_faq: "FAQ",
    nav_login: "Iniciar sesion",
    nav_cta: "Empezar",

    hero_badge: "Looksmaxxing con IA",
    hero_title_1: "Tu Glow-Up,",
    hero_title_2: "cientificamente",
    hero_title_3: "visualizado.",
    hero_desc: "Sube una selfie y ve en segundos como podrias lucir con piel, peinado y rasgos faciales optimizados — con un plan concreto para lograrlo.",
    hero_cta: "Probar gratis",
    hero_cta_join: "Únete al Club",
    hero_sub: "Sin suscripcion necesaria",
    ba_label: "Resultados",
    ba_title: "Mira la transformación",

    trust_label: "Basado en",
    trust_items: ["GPT-4 Vision", "Gemini Imagen", "Investigacion Estetica Facial", "10.000+ Analisis"],

    steps_label: "Como funciona",
    steps_title_1: "Cuatro pasos hacia",
    steps_title_2: "tu mejor version",
    step_1_title: "Subir foto",
    step_1_desc: "Sube una selfie frontal con buena luz — sin filtro, sin maquillaje.",
    step_2_title: "Analisis IA",
    step_2_desc: "Nuestra IA analiza rasgos faciales, proporciones, calidad de piel y potencial de estilo.",
    step_3_title: "Visualizacion",
    step_3_desc: "Ve tu yo optimizado — con mejoras realistas generadas en tiempo real.",
    step_4_title: "Plan personal",
    step_4_desc: "Recibe un plan concreto y accionable con rutinas y consejos.",

    compare_label: "Por que Beauly",
    compare_title_1: "La forma antigua vs.",
    compare_title_2: "la nueva forma",
    old_title: "La forma antigua",
    old_items: [
      "Horas viendo videos de YouTube",
      "Consejos genericos sin personalizacion",
      "Sin vista previa — pura adivinanza",
      "Consultas costosas con estilistas",
      "Prueba y error sin resultados",
    ],
    new_title: "La nueva forma",
    new_items: [
      "Analisis IA instantaneo en segundos",
      "100% personalizado para tu rostro",
      "Vista previa realista de cambios",
      "Plan paso a paso concreto",
      "Recomendaciones basadas en ciencia",
    ],

    cat_label: "Que analizamos",
    cat_title_1: "Cada detalle de tu apariencia,",
    cat_title_2: "optimizado",
    cat_skin_title: "Piel",
    cat_skin_desc: "Piel mas clara y radiante con rutinas de skincare personalizadas y recomendaciones.",
    cat_hair_title: "Peinado",
    cat_hair_desc: "El corte perfecto para tu forma de rostro — con instrucciones de estilo y consejos.",
    cat_face_title: "Estructura facial",
    cat_face_desc: "Mandibula, pomulos, simetria — ve como pequenos cambios generan un gran impacto.",
    cat_glasses_title: "Gafas y accesorios",
    cat_glasses_desc: "Que forma de marco favorece tu rostro? Que accesorios combinan con tu tipo?",
    cat_beard_title: "Barba y cejas",
    cat_beard_desc: "Forma, largo y cuidado optimos — adaptados a tus proporciones faciales.",
    cat_fitness_title: "Fitness y cuerpo",
    cat_fitness_desc: "Como los cambios de peso afectan tu rostro — con vista previa realista.",

    stat_1_value: "3.800+",
    stat_1_label: "Transformaciones",
    stat_2_value: "4.7",
    stat_2_label: "Valoración",
    stat_3_value: "<30s",
    stat_3_label: "hasta resultados",

    test_label: "Testimonios",
    test_title_1: "Lo que nuestros usuarios",
    test_title_2: "dicen",
    test_1_text: "Nunca pense que un corte de pelo diferente pudiera hacer tanta diferencia. Beauly me mostro exactamente cual se adapta a mi forma de rostro.",
    test_1_name: "Lucas M.",
    test_1_loc: "Viena, Austria",
    test_2_text: "Las recomendaciones de skincare mejoraron visiblemente mi piel en 4 semanas. Por fin consejos realmente adaptados a mi.",
    test_2_name: "Sarah K.",
    test_2_loc: "Los Ángeles, EE.UU.",
    test_3_text: "Super genial ver como me veria con una mandibula definida — y el plan de fitness es realista y factible.",
    test_3_name: "Wang Wei",
    test_3_loc: "Shanghái, China",
    test_4_text: "Beauly me ayudó a repensar completamente mi estilo. Las visualizaciones son increíblemente realistas.",
    test_4_name: "Anna L.",
    test_4_loc: "Madrid, España",
    test_5_text: "Por fin una plataforma que me muestra concretamente lo que es posible. La recomendación de barba fue un cambio total.",
    test_5_name: "Max B.",
    test_5_loc: "Moscú, Rusia",
    test_6_text: "La consulta de gafas me convenció. Nunca pensé que la forma del marco pudiera marcar tanta diferencia.",
    test_6_name: "Elena S.",
    test_6_loc: "Lisboa, Portugal",

    faq_label: "FAQ",
    faq_title_1: "Preguntas",
    faq_title_2: "frecuentes",
    faq_1_q: "Como funciona el analisis de IA?",
    faq_1_a: "Nuestra IA utiliza generacion de imagenes avanzada y analisis facial para analizar tu foto. Luego se visualizan mejoras realistas — todo basado en proporciones esteticas y metodos probados.",
    faq_2_q: "Estan seguras mis fotos?",
    faq_2_a: "Si. Tus fotos se transfieren encriptadas y nunca se comparten con terceros. Puedes eliminar tus datos en cualquier momento.",
    faq_3_q: "¿Qué puedo esperar de Beauly?",
    faq_3_a: "Obtienes un análisis completo de tu rostro con IA, visualizaciones realistas y un plan personal — tu resultado está listo en menos de 30 segundos.",
    faq_4_q: "Son realistas las imagenes?",
    faq_4_a: "Si. Usamos generacion de imagenes de ultima generacion que ofrece resultados naturales y realistas — sin filtros exagerados ni cambios irrealistas.",
    faq_5_q: "Funciona para todos los generos?",
    faq_5_a: "Absolutamente. Beauly funciona para todos los generos, etnias y grupos de edad. Las recomendaciones se adaptan individualmente.",

    cta_title_1: "¿Listo para tu",
    cta_title_2: "mejor look?",
    cta_desc: "Tu resultado está listo en menos de 30 segundos. Solo sube una selfie y listo.",
    cta_button: "Empezar ahora",

    footer_how: "Como funciona",
    footer_features: "Funciones",
    footer_faq: "FAQ",

    auth_back: "Volver",
    auth_subtitle: "Tu asistente de estilo personal",
    auth_login: "Iniciar sesion",
    auth_register: "Registrarse",
    auth_email: "Correo electronico",
    auth_password: "Contrasena",
    auth_name: "Nombre",
    auth_no_account: "No tienes cuenta? Registrate",
    auth_has_account: "Ya registrado? Inicia sesion",

    chat_new: "Nuevo analisis",
    chat_no_chats: "Sin chats aun",
    chat_default_title: "Beauly — Tu asistente de estilo",
    chat_welcome: "Bienvenido a Beauly",
    chat_welcome_desc: "Sube una foto tuya y te mostrare como podrias lucir con un corte de pelo, barba o estilo diferente.",
    chat_suggest_1: "Analiza mi rostro",
    chat_suggest_2: "Que corte me queda?",
    chat_suggest_3: "Rutina skincare para principiantes",
    chat_suggest_4: "Muestra mi glow-up",
    chat_upload: "Subir foto",
    chat_image_active: "Modo imagen activo",
    chat_image_enable: "Activar modo imagen",
    chat_placeholder: "Mensaje a Beauly...",
    chat_placeholder_image: "Describe el cambio deseado...",
    chat_image_hint: "Modo imagen activo — Sube una foto y describe el cambio deseado",
    chat_generating: "Generando imagen...",
    chat_generated: "Imagen generada",
    chat_disclaimer: "Beauly puede cometer errores. Los resultados son generados por IA y sirven como orientacion.",
    chat_logout: "Cerrar sesion",
    chat_new_conv: "Nueva conversacion",
    chat_delete_account: "Eliminar cuenta",
    chat_delete_title: "¿Eliminar cuenta?",
    chat_delete_warning: "Todos tus datos, historial de chat e imágenes serán eliminados permanentemente. Esta acción no se puede deshacer.",
    chat_delete_cancel: "Cancelar",
    chat_delete_continue: "Continuar",
    chat_delete_type_title: "Confirmación requerida",
    chat_delete_type_desc: "Escribe tu nombre para confirmar la eliminación:",
    chat_delete_confirm: "Eliminar permanentemente",
    auth_error_name: "Por favor ingresa tu nombre.",
    auth_error_email: "Por favor ingresa tu correo.",
    auth_error_password: "Por favor ingresa una contraseña.",
    paywall_title: "Desbloquea Beauly",
    paywall_desc: "Pago único — sin suscripción, sin costos ocultos.",
    paywall_period: "único",
    paywall_feature_1: "Análisis de IA de tu rostro",
    paywall_feature_2: "Visualización realista antes/después",
    paywall_feature_3: "Plan de estilo personal",
    paywall_feature_4: "Conversaciones de chat ilimitadas",
    paywall_cta: "Desbloquear ahora",
    paywall_logout: "Cerrar sesión",
    camera_title: "Tomar una foto",
    camera_take: "Abrir cámara",
    camera_gallery: "Elegir de galería",
    camera_retake: "Repetir",
    camera_send: "Analizar",
    credits_messages: "Mensajes",
    credits_images: "Imágenes",
    credits_buy: "Comprar créditos",
    credits_exhausted_title: "Créditos agotados",
    credits_exhausted_desc: "Has usado todos tus créditos. Compra más para seguir usando Beauly.",
    credits_exhausted_info: "10 imágenes + 30 mensajes por compra",
    credits_buy_now: "Comprar créditos ahora",
    credits_later: "Después",
  },

  zh: {
    nav_how: "工作原理",
    nav_features: "功能",
    nav_faq: "常见问题",
    nav_login: "登录",
    nav_cta: "开始使用",

    hero_badge: "AI驱动的颜值提升",
    hero_title_1: "你的蜕变，",
    hero_title_2: "科学地",
    hero_title_3: "可视化。",
    hero_desc: "上传自拍，几秒内看到你优化肤质、发型和面部特征后的样子——并获得实现目标的具体计划。",
    hero_cta: "免费试用",
    hero_cta_join: "加入俱乐部",
    hero_sub: "无需订阅",
    ba_label: "效果展示",
    ba_title: "看看变化",

    trust_label: "技术支持",
    trust_items: ["GPT-4 Vision", "Gemini Imagen", "面部美学研究", "10,000+ 分析"],

    steps_label: "工作原理",
    steps_title_1: "四步实现",
    steps_title_2: "最佳形象",
    step_1_title: "上传照片",
    step_1_desc: "上传一张光线良好的正面自拍——无滤镜、无妆容。",
    step_2_title: "AI分析",
    step_2_desc: "我们的AI分析面部特征、比例、肤质和造型潜力。",
    step_3_title: "效果预览",
    step_3_desc: "看到优化后的自己——实时生成的真实改进效果。",
    step_4_title: "个人计划",
    step_4_desc: "获得具体可行的计划，包括日常护理和建议。",

    compare_label: "为什么选择Beauly",
    compare_title_1: "旧方式 vs.",
    compare_title_2: "新方式",
    old_title: "旧方式",
    old_items: [
      "花数小时看YouTube视频",
      "没有个性化的通用建议",
      "没有预览——纯靠猜测",
      "昂贵的造型师咨询",
      "反复试错没有结果",
    ],
    new_title: "新方式",
    new_items: [
      "几秒内完成AI即时分析",
      "100%针对你的面部定制",
      "真实的变化预览",
      "具体的分步计划",
      "基于科学的推荐",
    ],

    cat_label: "我们分析什么",
    cat_title_1: "你外表的每一个细节，",
    cat_title_2: "都被优化",
    cat_skin_title: "皮肤",
    cat_skin_desc: "通过个性化护肤方案和推荐，获得更清透、光彩的肌肤。",
    cat_hair_title: "发型",
    cat_hair_desc: "适合你脸型的完美发型——附带造型指导和建议。",
    cat_face_title: "面部结构",
    cat_face_desc: "下颌线、颧骨、对称性——看看微小改变如何产生巨大影响。",
    cat_glasses_title: "眼镜与配饰",
    cat_glasses_desc: "哪种镜框最衬你的脸？哪些配饰适合你的风格？",
    cat_beard_title: "胡须与眉毛",
    cat_beard_desc: "最佳形状、长度和护理——根据你的面部比例量身定制。",
    cat_fitness_title: "健身与身材",
    cat_fitness_desc: "体重变化如何影响你的面部——提供真实预览。",

    stat_1_value: "3,800+",
    stat_1_label: "次变身",
    stat_2_value: "4.7",
    stat_2_label: "用户评分",
    stat_3_value: "<30秒",
    stat_3_label: "出结果",

    test_label: "用户评价",
    test_title_1: "我们的用户",
    test_title_2: "怎么说",
    test_1_text: "我从没想过不同的发型能带来这么大的变化。Beauly精确地告诉我哪种发型适合我的脸型。",
    test_1_name: "Lucas M.",
    test_1_loc: "维也纳，奥地利",
    test_2_text: "护肤推荐在4周内明显改善了我的肤质。终于有了真正为我量身定制的建议。",
    test_2_name: "Sarah K.",
    test_2_loc: "洛杉矶，美国",
    test_3_text: "看到自己拥有明显下颌线的样子太酷了——而且健身计划切实可行。",
    test_3_name: "Wang Wei",
    test_3_loc: "上海，中国",
    test_4_text: "Beauly帮助我彻底重新审视了我的风格。可视化效果令人难以置信地真实。",
    test_4_name: "Anna L.",
    test_4_loc: "马德里，西班牙",
    test_5_text: "终于有一个平台能具体展示什么是可能的。胡须建议是一个颠覆性的改变。",
    test_5_name: "Max B.",
    test_5_loc: "莫斯科，俄罗斯",
    test_6_text: "眼镜咨询让我信服了。没想到镜框形状能产生这么大的区别。",
    test_6_name: "Elena S.",
    test_6_loc: "里斯本，葡萄牙",

    faq_label: "常见问题",
    faq_title_1: "常见",
    faq_title_2: "问题",
    faq_1_q: "AI分析是如何工作的？",
    faq_1_a: "我们的AI使用先进的图像生成和面部分析技术来分析你的照片。然后可视化展示真实的改进效果——一切基于美学比例和经过验证的方法。",
    faq_2_q: "我的照片安全吗？",
    faq_2_a: "是的。你的照片经过加密传输，绝不会与第三方共享。你可以随时删除你的数据。",
    faq_3_q: "Beauly能为我做什么？",
    faq_3_a: "你将获得完整的AI面部分析、逼真的可视化效果和个人计划——结果在30秒内即可呈现。",
    faq_4_q: "生成的图像真实吗？",
    faq_4_a: "是的。我们使用最先进的图像生成技术，提供自然真实的效果——没有夸张的滤镜或不切实际的变化。",
    faq_5_q: "适用于所有性别吗？",
    faq_5_a: "当然。Beauly适用于所有性别、种族和年龄段。推荐都是个性化定制的。",

    cta_title_1: "准备好迎接你的",
    cta_title_2: "最佳形象了吗？",
    cta_desc: "30秒内即可获得结果。只需上传自拍即可开始。",
    cta_button: "立即开始",

    footer_how: "工作原理",
    footer_features: "功能",
    footer_faq: "常见问题",

    auth_back: "返回",
    auth_subtitle: "你的个人造型助手",
    auth_login: "登录",
    auth_register: "注册",
    auth_email: "邮箱",
    auth_password: "密码",
    auth_name: "姓名",
    auth_no_account: "还没有账号？注册",
    auth_has_account: "已有账号？登录",

    chat_new: "新分析",
    chat_no_chats: "暂无聊天",
    chat_default_title: "Beauly — 你的造型助手",
    chat_welcome: "欢迎来到 Beauly",
    chat_welcome_desc: "上传一张你的照片，我会展示不同发型、胡须或风格下你的样子。",
    chat_suggest_1: "分析我的脸",
    chat_suggest_2: "什么发型适合我？",
    chat_suggest_3: "新手护肤方案",
    chat_suggest_4: "展示我的蜕变",
    chat_upload: "上传照片",
    chat_image_active: "图像模式已激活",
    chat_image_enable: "启用图像模式",
    chat_placeholder: "发消息给 Beauly...",
    chat_placeholder_image: "描述你想要的变化...",
    chat_image_hint: "图像模式已激活——上传照片并描述你想要的变化",
    chat_generating: "正在生成图像...",
    chat_generated: "生成的图像",
    chat_disclaimer: "Beauly可能会出错。结果由AI生成，仅供参考。",
    chat_logout: "退出登录",
    chat_new_conv: "新对话",
    chat_delete_account: "删除账户",
    chat_delete_title: "删除账户？",
    chat_delete_warning: "你的所有数据、聊天记录和图片将被永久删除。此操作无法撤销。",
    chat_delete_cancel: "取消",
    chat_delete_continue: "继续",
    chat_delete_type_title: "需要确认",
    chat_delete_type_desc: "输入你的姓名以确认删除：",
    chat_delete_confirm: "永久删除",
    auth_error_name: "请输入你的姓名。",
    auth_error_email: "请输入你的邮箱。",
    auth_error_password: "请输入密码。",
    paywall_title: "解锁 Beauly",
    paywall_desc: "一次性付款——无订阅，无隐藏费用。",
    paywall_period: "一次性",
    paywall_feature_1: "AI面部分析",
    paywall_feature_2: "真实的前后对比可视化",
    paywall_feature_3: "个人造型计划",
    paywall_feature_4: "无限聊天对话",
    paywall_cta: "立即解锁",
    paywall_logout: "退出登录",
    camera_title: "拍照",
    camera_take: "打开相机",
    camera_gallery: "从相册选择",
    camera_retake: "重拍",
    camera_send: "分析",
    credits_messages: "消息",
    credits_images: "图片",
    credits_buy: "购买积分",
    credits_exhausted_title: "积分已用完",
    credits_exhausted_desc: "你的积分已用完。购买更多积分以继续使用Beauly。",
    credits_exhausted_info: "每次购买10张图片 + 30条消息",
    credits_buy_now: "立即购买积分",
    credits_later: "稍后",
  },
};

export default translations;
